<div class="t-popup-body" style="overflow: auto;font-size:large;width: 50em;" [formGroup]="gfs.Form">
    <button class="t-btn-popup-close" aria-label="close popup" (click)="close(true)"></button>
    <div class="formHeader">
        <h2 style="align-self: center;">
            Time Out Form
        </h2>
        <span (click)="printForm()" class="icon-print" style="margin-inline-end: 1.5em;"
            aria-label="Print" matTooltip="Print"><img src="../../../assets/icons/print.svg"></span>
    </div>
    <div class="m-box" style="direction: rtl; margin: 1em 0; justify-content: space-between;">
        <section class="w100" style="direction: rtl; justify-content: space-evenly; display: flex;">
            <span>זיהוי מטופל <input type="checkbox" formControlName="PatientIdentification"></span>
            <span> בדיקות לביצוע:</span>
            <span>קולונוסקופיה <input type="checkbox" formControlName="Colonoscopy"></span>
            <span>גסטרוסקופיה <input type="checkbox" formControlName="Gastroscopy"></span>
            <span>סיגמואידוסקופיה <input type="checkbox" formControlName="Sigmoidoscopy"></span>
        </section>
        <div style="display: flex; justify-content: space-around;width: 70%;">
            <div class="w20" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 0.3em; align-self: center;">
                    שעת קבלה
                </span>
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="time" id="CheckTime" formControlName="AdmissionTime" />
                </span>
            </div>
            <div class="w20" style="display: flex;margin-top: 0; margin: 0.3em;">
                <span style="margin-left: 0.3em; align-self: center;">
                    רופא
                </span>
                <span class="t-field t-field--number" style="direction: rtl;">
                    <input class="t-field-text" type="text" formControlName="AssignedDoctor" />
                </span>
            </div>
        </div>
    </div>
    <section class="w100" style="direction: rtl;justify-content: space-evenly;display: flex;flex-direction: column;">
        <div class="l-flex-c l-flex-w indicative-fieldset" style="flex-wrap: inherit;flex-direction: column;">
            
            
           
             <div style="width: 100%;">
                <label class="t-label-top">
                    <span style="width: 18em;">  השם ומספר ת.ז תואמים לפרטי הנבדק/ת    </span>
                    <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('IdentetyMatchBreclate').setValue(-1)">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="IdentetyMatchBreclate" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                כן
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="IdentetyMatchBreclate" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא
                            </span>

                        </label>
                    </div>
                </label>

            </div>
            <div style="width: 100%;">
                <label class="t-label-top">
                    <span style="width: 18em;"> הנבדק/ת חזר/ה בקול על ת.ז, שם ושם משפחה   </span>
                    <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('Identety').setValue(-1)">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="Identety" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                כן
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="Identety" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא
                            </span>

                        </label>
                    </div>
                </label>

            </div>
            <div style="width: 100%;">
                <label class="t-label-top">
                    <span style="width: 18em;"> זיהוי ע"י אופטרופוס</span>
                    <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('Guardian').setValue(-1);gfs.Form.get('GuardianName').setValue(null);gfs.Form.get('GuardianID').setValue(null)">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="Guardian" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                כן
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="Guardian" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא
                            </span>

                        </label>
                        <div *ngIf="gfs.Form.get('Guardian').value=='1'">
                            <span>
                                שם:
                            </span>
                            <input class="t-field t-field-text" formControlName="GuardianName" />
                            <span>
                                ת.ז:
                            </span>
                            <input class="t-field t-field-text" formControlName="GuardianID" />
                        </div>
                       
                    </div>
                </label>

            </div>
            <div style="width: 100%;">
                <label class="t-label-top">
                    <span style="width: 18em;">הפרטים במסמכים תואמים לפרטי המטופל  </span>
                    <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('IdentetyMatchDocumante').setValue(-1);">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="IdentetyMatchDocumante" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                כן
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="IdentetyMatchDocumante" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא
                            </span>

                        </label>
                    </div>
                </label>

            </div>
            <div style="width: 100%;">
                <label class="t-label-top">
                    <span style="width: 18em;">שיניים תותבות</span>
                    <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('Prosthesis').setValue(-1);">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="Prosthesis" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                כן
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="Prosthesis" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא
                            </span>

                        </label>
                    </div>
                </label>

            </div>
            <div style="width: 100%;">
                <label class="t-label-top">
                    <span style="width: 18em;">תרופות נגד קרישיות דם </span>
                    <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('DAC').setValue(-1);">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="DAC" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                כן
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="DAC" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא
                            </span>

                        </label>
                    </div>
                    <div>
                        <span>
                            פירוט:
                        </span>
                        <input class="t-field t-field-text" formControlName="DACComments" />
                    </div>
                    <!-- <section >
                        <textarea  class="t-field t-field-text" style="margin-left: 0;top:0;width: 100%;background-color: #e4eded;border-radius: 0;" formControlName="DACComments" placeholder="פירוט"></textarea>
                    </section> -->
                    <button class="t-btn-edit"
                    (click)="atS.showAuto(gfs.Form.get('DACComments'),'תרופות נגד קרשיות דם',1751)">Auto Text</button>
                </label>

            </div>
            <div style="width: 100%;">
                <label class="t-label-top">
                    <span style="width: 18em;">טפסי הסכמה לסדציה </span>
                    <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('validconcentFormSedation').setValue('');">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="validconcentFormSedation" value="valid"><i
                                class="customInput-display"></i>

                            <span>
                                תקין
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="validconcentFormSedation" value="notvalid"><i
                                class="customInput-display"></i>

                            <span>
                                לא תקין
                            </span>

                        </label>
                    </div>
                </label>

            </div>
            <div style="width: 100%;">
                <label class="t-label-top">
                    <span style="width: 18em;">טפסי הסכמה לפעולה </span>
                    <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('validconcentFormAction').setValue('');">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="validconcentFormAction" value="valid"><i
                                class="customInput-display"></i>

                            <span>
                                תקין
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="validconcentFormAction" value="notvalid"><i
                                class="customInput-display"></i>

                            <span>
                                לא תקין
                            </span>

                        </label>
                    </div>
                </label>

            </div>
            <div style="width: 100%;">
                <label class="t-label-top">
                    <span style="width: 18em;"> זמינות ותקינות ציוד בחדר </span>
                    <div  style="margin-top: 0;" (dblclick)="gfs.Form.get('Equipment').setValue(-1);">

                        <label class="observe">

                            <input type="radio" class="custom-check customInput" formControlName="Equipment" [value]="1"><i
                                class="customInput-display"></i>

                            <span>
                                תקין
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" formControlName="Equipment" [value]="0"><i
                                class="customInput-display"></i>

                            <span>
                                לא תקין
                            </span>

                        </label>
                    </div>
                    <div>
                        <span>
                            פירוט:
                        </span>
                        <input class="t-field t-field-text" formControlName="EquipmentNote" />
                    </div>
                </label>

            </div>
            <div style="width: 100%;">
                <label class="t-label-top">
                    <span style="width: 18em;">סדציה</span>
                    <select class="t-field t-field-select" formControlName="MedicationType" style="width: 12em;">
                        <option value="ביאטריל">ביאטריל</option>
                        <option value="דורמיקום">דורמיקום</option>
                        <option value="פרופופול">פרופופול</option>
                    </select>
                    
                </label>
            </div>
            <div style="display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;">
            <div style="width: 70%;">
            <div style="width: 100%;">
            
                <div style="width: 100%;display: flex;flex-direction: row;justify-content:space-around;">
                    <mat-form-field>
                        <mat-label [ngClass]="['mat-select-value']">  רגישות לחומרים</mat-label>
                        <mat-select [formControl]="gfs.Form.get('medSens')" multiple [ngClass]="['mat-select-value','mat-form-field']">
                          <mat-option *ngFor="let sensitivity of sensitivitiesDropdownList" [value]="sensitivity" [ngClass]="['mat-select-value']">{{sensitivity}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div style="display: flex; justify-content: center; align-items: center;">
                        <input class="t-field t-field-text" placeholder="הוספת רגישות אחרת"  [(ngModel)]="extraSensitivities"  [ngModelOptions]="{standalone: true}"/>
                        <button class="btnAdd" (click)="addSensitivity()">הוסף</button>
                    </div>
                </div>
                    
               
            </div>
            
        
            

            <span class="l-flex-w" style="width: 100%; padding: 5px 0;">
                <label class="t-label-top w100">
                  <span style="width: 33%; text-align: center;">
                    <strong>תאריך:</strong> {{ gfs.Form.get('CreationTime').value ? (gfs.Form.get('CreationTime').value | date:"dd-MM-yyyy") : (currentDate | date:"dd-MM-yyyy") }}
                  </span>
                  <span style="width: 33%; text-align: center;">
                    <strong>שעה:</strong> {{ gfs.Form.get('CreationTime').value ? (gfs.Form.get('CreationTime').value | date: "HH:mm") : (currentTime | date: "HH:mm") }}
                  </span>
                </label>
              </span>
              <div style="width: 100%;">
            
                <div style="width: 100%;display: flex;flex-direction: row;justify-content:space-around;">
                    <mat-form-field>
                        <mat-label [ngClass]="['mat-select-value']"> שמות הממלאים </mat-label>
                        <mat-select [formControl]="gfs.Form.get('ResponsibleForm')" multiple [ngClass]="['mat-select-value','mat-form-field']">
                          <mat-option *ngFor="let charge of responsibleList" [value]="charge" [ngClass]="['mat-select-value']">{{charge}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div style="display: flex; justify-content: center; align-items: center;">
                        <input class="t-field t-field-text" placeholder="הוסף ממלא לטופס"  [(ngModel)]="responsible"  [ngModelOptions]="{standalone: true}"/>
                        <button class="btnAdd" (click)="addResponsible()">הוסף</button>
                    </div>
                </div>
                    
               
            </div>
            
        </div>
        <div style="width: 30%;">
        <div style="display: grid;place-self: center;">
            <span>חתימת רופא/ה:</span>
            <canvas id="canvasDoc" #canvasDocSign [style.border]="'1px solid black'" [ngClass]="'can-shadow'" width="200"
                height="100" (click)="setDocCanvas()"></canvas>
            <button style="position: relative;top: -2em;width: fit-content;" (click)="clearDocSign()">
                <ng-container>
                    <img src="../../assets/icons/login/reset.png" style='height: 1.5em;width: 1.5em' matTooltip="Clear">
                </ng-container>
            </button>
        
        </div>
            <div style="display: grid;place-self: center;">
                <span>חתימת האח/ות:</span>
                <canvas id="canvasNurse" #canvasSign [style.border]="'1px solid black'"  [ngClass]="'can-shadow'" width="200" height="100"   (click)="setCanvas()"></canvas>
                <button   style="position: relative;top: -2em;width: fit-content;" (click)="clearSign()">                                            
                    <ng-container>
                        <img src="../../assets/icons/login/reset.png" style='height: 1.5em;width: 1.5em' matTooltip="Clear">
                    </ng-container>
                </button>
                <button style="width: 10%;" class="accept" (click)="close(true)">Save and Close</button>
        
            </div>
    </div>
</div>
              
</div>
<app-autotext *ngIf="atS.Display"></app-autotext>

